import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '37px'
  },

  dot: {
    borderRadius: '50%',
    width: '10px',
    height: '10px',
    backgroundColor: ({ online }) =>
      online ? theme.palette.indicator.green : 'lightgrey'
  }
}))

export default useStyles
